export default {
  id: 'SchoolSettings',
  code: 'CN',
  text: {
    'Permissions': '权限设置',
    'School Settings': '学校设置',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolSettings/locale.js